import React from "react";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import { Edit } from "@mui/icons-material";

import EmptyResult from "./Lottie/EmptyResult";

import { useAuth } from "hooks/useAuth";

const HistoryTimeline = ({ timelineItems = [] }) => {
  const { getAuthorName } = useAuth();

  const getAuthorTypeLabel = (createdBy) => {
    return (
      {
        VendorProfile: "Vendor",
        VendorStaff: "Vendor Staff",
      }[createdBy?.typeRefSource] || ""
    );
  };

  return !!timelineItems?.length ? (
    <Timeline>
      {timelineItems?.map((item, index) => (
        <React.Fragment key={item?._id}>
          <TimelineItem>
            <TimelineOppositeContent color="textSecondary">
              <div>{new Date(item?.createdAt)?.toLocaleDateString()}</div>

              <div className="text-sm">
                {new Date(item?.createdAt)?.toLocaleTimeString()}
              </div>
            </TimelineOppositeContent>

            <TimelineSeparator>
              <TimelineDot variant="outlined">
                <Edit fontSize="small" color="primary" />
              </TimelineDot>

              {index !== timelineItems?.length - 1 && <TimelineConnector />}
            </TimelineSeparator>

            <TimelineContent>
              <div className="text-sm font-medium text-blue-500 dark:text-blue-200">
                {getAuthorName(item?.createdBy)}

                {getAuthorTypeLabel(item?.createdBy) && (
                  <span
                    style={{ color: "gray", fontSize: 13, marginLeft: "5px" }}
                  >
                    ( {getAuthorTypeLabel(item?.createdBy)} )
                  </span>
                )}
              </div>

              <div>{item?.comment}</div>
            </TimelineContent>
          </TimelineItem>
        </React.Fragment>
      ))}
    </Timeline>
  ) : (
    <EmptyResult height={150} label="No history found!" />
  );
};

export default HistoryTimeline;
